<template>
  <router-view v-if="applicationReady" />
</template>

<script>
import SessionService from 'services/SessionService';
import CurrentStudentService from 'services/CurrentStudentService';
import AppConfig from 'utils/app-config';

export default {
  data() {
    return {
      applicationReady: false,
    };
  },
  beforeMount() {
    this.recoverSessionIfExists();
  },
  methods: {
    async recoverSessionIfExists() {
      const jwt = await this.retrieveJWT();

      if (jwt) {
        SessionService.set(jwt);
        AppConfig.merge({ authToken: jwt });
        this.redirectToPanel();
      }

      this.applicationReady = true;
    },
    retrieveJWT() {
      if (this.$route.query.impersonating) {
        return CurrentStudentService.impersonationToken()
          .then(({ jwt }) => jwt)
          .catch(() => {
            this.$toast.show('danger', 'Erro ao impersonar aluno, tente novamente mais tarde', 4000);

            return false;
          });
      }

      return SessionService.get();
    },
    redirectToPanel() {
      if (
        this.$route.matched
        && this.$route.matched[0].meta
        && (this.$route.matched[0].meta.private || this.$route.matched[0].meta.confirmationPage)
      ) {
        return;
      }

      this.$router.replace('/painel');
    },
  },
};
</script>
